import { useState, useEffect } from "react";
import "../challenge-joining-frames.css";
import Logo from "../../../../../ui/atoms/logo/Logo";
import BackgroundPaths from "../../../../../ui/molecules/background-paths/BackgroundPaths";
import InputText from "../../../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../../../ui/atoms/buttons/Button";
import { GiTeamIdea } from "react-icons/gi";
import { isEmpty } from "../../../../../core/utils/helpers";
import ASSETS from "../../../../../app/config/assets";
import useAxiosPrivate from "../../../../../app/providers/context-provider/useAxiosPrivate";

const JoiningTeamChoiceFrame = () => {
  const axiosPrivate = useAxiosPrivate();
  
  const [isSending, setIsSending] = useState(false);

  return (
    <div className="joining-frame">
      <div className="j-f-inner">
        <BackgroundPaths />
      </div>
      <div className="j-f-outer">
        <div className="j-f-outer-head">
          <Logo to={null} width={"200px"} />
          <h1>Pamoja 4 Machine Intelligence University</h1>
          <div className="w-fit-content d-flex justify-center align-center p-xs">
            <GiTeamIdea className="icon" />
            <span>Team Mode</span>
          </div>
          <p>Choose your prefered Team.!</p>
        </div>
        <div className="j-f-outer-wrapper team-choice-container">
          <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div>
          <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div>
          <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div>
          {/* <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div>
          <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div>
          <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div>
          <div className="team-item">
            <img
              src={ASSETS?.icon_brain_light_png}
              alt="team symbol illustration"
              className="team-icon"
            />
            <div className="t-i-head">
              <h3>Team's Name</h3>
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Join, Go!"}
                action={() => {}}
              />
            </div>
            <div className="t-i-members">
              <span>Member 1</span>
              <span>Member 2</span>
              <span>Member 3</span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default JoiningTeamChoiceFrame;
